<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <!-- <em>筛选：</em> -->
        <div class="item-wp">
          <template v-if="searchShow">
            <div class="item-son">
              <el-input
                  v-model="listParams.searchKey"
                  placeholder="搜索关键词"
                  @keyup.enter.native="SearchChannelList"
              ></el-input>
            </div>
            <div class="item-son">
              <el-select
                  v-model="listParams.status"
                  clearable
                  placeholder="请选择状态"
                  style="width: 120px"
              >
                <el-option label="正常" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
              </el-select>
            </div>
            <div class="item-son">
              <el-button type="primary" @click="SearchChannelList"
              >查询 <i class="el-icon-search"></i>
              </el-button>
            </div>
          </template>

          <div class="item-son" v-if="addShow">
            <el-button type="primary" @click="handleClick('add')"
            >新增 <img src="@assets/images/add-icon.png" alt=""/>
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="public-table-data">
      <el-table
          ref="multipleTable"
          size="medium"
          :data="tableData"
          border
          style="width: 100%"
          row-key="menuId"
          v-loading="loading"
      >
        <el-table-column
            align="center"
            fixed
            label="序号"
            type="index"
            width="100"
        >
          <template slot-scope="scope">
                <span>{{
                    (pages.pageNo - 1) * pages.pageSize + scope.$index + 1
                  }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" width="120" align="center">
        </el-table-column>

        <el-table-column prop="code" label="代码" width="200" align="center">
        </el-table-column>

        <el-table-column
            prop="channelTypes"
            label="渠道"
            width="150"
            align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.channelTypes | channelTypes }}
          </template>
        </el-table-column>
        <el-table-column
            prop="contactName"
            label="联系人"
            width="120"
            align="center"
        >
        </el-table-column>
        <el-table-column
            prop="contactTel"
            label="联系电话"
            width="150"
            align="center"
        >
        </el-table-column>
        <el-table-column prop="descr" label="说明" width="200" align="center">
        </el-table-column>

        <el-table-column prop="ctime" label="时间" width="200" align="center">
        </el-table-column>

        <el-table-column prop="code" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
                :disabled="statusShow"
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                @change="changeSwitch(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" fixed="right" min-width="180">
          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="handleClick('edit', scope.row)"
                type="warning"
                plain
                v-if="editShow"
            >编辑
            </el-button
            >
            <el-button
                size="mini"
                @click="handleDelete(scope.row)"
                type="primary"
                plain
                v-if="deleteShow"
            >删除
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="public-pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.pageNo"
            :page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑渠道商户信息"
        :visible.sync="dialogVisible"
        width="460px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-form-item label="名称" prop="name">
            <el-input placeholder="请填写名称" v-model="params.name" clearable></el-input>
          </el-form-item>

          <el-form-item label="代码" prop="code">
            <el-input placeholder="请填写代码" v-model="params.code" clearable></el-input>
          </el-form-item>

          <el-form-item prop="channelTypes" label="渠道">
            <el-select clearable
                       v-model="params.channelTypes"
                       multiple
                       filterable
                       placeholder="请选择渠道"
                       style="width: 100%"
            >
              <el-option
                  v-for="(item, index) in channelData"
                  :key="index"
                  :label="item.name"
                  :value="item.channelType"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="联系人" prop="contactName">
            <el-input clearable
                      placeholder="请填联系人"
                      v-model="params.contactName"
            ></el-input>
          </el-form-item>

          <el-form-item label="联系电话" prop="contactTel">
            <el-input clearable
                      placeholder="请填联系电话"
                      v-model="params.contactTel"
            ></el-input>
          </el-form-item>

          <el-form-item label="说明" prop="descr">
            <el-input clearable
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      placeholder="请输入说明"
                      v-model="params.descr"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {PAGE_SIZE, FILE_ROOT, JOB_STATUS} from "@config";

export default {
  filters: {
    channelTypes(arr) {
      //`<el-tag effect="dark">${obj.name}</el-tag>`
      if (arr) {
        let tag = arr
            .map(function (obj, index) {
              return obj.name;
            })
            .join(" ");
        return tag;
      }
    },
  },
  data() {
    return {
      listParams: {},
      params: {},
      tableData: [],
      channelData: [],
      dialogVisible: false,
      total: 0,
      PAGE_SIZE,
      pages: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      loading: false,
      rules: {
        name: [{required: true, message: "请填写名称", trigger: "change"}],

        code: [{required: true, message: "请填代码", trigger: "change"}],
        channelTypes: [
          {required: true, message: "请选择渠道", trigger: "blur"},
        ],
        contactName: [
          {required: true, message: "请填写联系人", trigger: "change"},
        ],
        contactTel: [
          {required: true, message: "请填写联系电话", trigger: "change"},
          {
            message: "联系电话不符合规范", trigger: "blur", pattern:
                /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
          },
        ],
        // descr: [{ required: true, message: "请填写说明", trigger: "change" }],
      },
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
    };
  },

  created() {
    this.queryTableData();
    this.channelList();
    this.getPermissionButtonList()
  },

  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'channel:mch:query') {
            this.searchShow = true
          }
          if (item.code == 'channel:mch:add') {
            this.addShow = true
          }
          if (item.code == "channel:mch:delete") {
            this.deleteShow = true
          }
          if (item.code == "channel:mch:edit") {
            this.editShow = true
          }
          if (item.code == "channel:mch:status") {
            this.statusShow = false
          }
        })
      }
    },
    SearchChannelList() {
      this.pages.pageNo = 1
      this.queryTableData()
    },
    /**
     * 获取列表
     */
    async queryTableData() {
      this.loading = true;

      const {data: resData} = await this.$get("channel/mch/list", {
        params: {
          ...this.listParams,
          ...this.pages,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data;
      this.total = resData.page.count;
    },
    /**
     * 修改渠道类型状态
     */
    async changeSwitch(b) {
      const {data: resData} = await this.$put(
          `channel/mch/info/status/${b.channelMchId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.$message({
        message: resData.message,
        type: "success",
      });
    },

    /**
     * 表格按钮点击
     */
    async handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "edit") {
        //编辑
        const {data: resData} = await this.$get(
            `channel/mch/info/${row.channelMchId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );

        if (resData.result != 200) return;
        let arr = [];
        resData.data.channelTypes.forEach((element) => {
          arr.push(element.channelType);
        });
        resData.data.channelTypes = arr;
        this.params = resData.data;
      }
    },

    /**
     * 编辑/增加
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add" || this.clickType == "addNext") {
            const {data: resData} = await this.$post(
                "channel/mch/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("添加成功!");
            this.params = {};
          } else {
            // this.params.channelTypes = this.params.channelTypes.toString();
            const {data: resData} = await this.$put(
                "channel/mch/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );

            if (resData.result != 200) return;

            this.queryTableData();

            this.dialogVisible = false;

            this.$message.success("修改成功!");
          }
        });
      });
    },
    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `channel/mch/info/${row.channelMchId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );

        if (resData.result != 200) return;
        this.$message.success("删除成功!");
        this.queryTableData();
      });
    },
    /**
     *  渠道列表
     */
    async channelList() {
      const {data: resData} = await this.$get("channel/type/list?paging=false", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      this.channelData = resData.data;
    },
    /**
     *  分页长度改变
     */
    handleSizeChange(val) {
      this.pages.pageNo = 1;
      this.pages.pageSize = val;

      this.queryTableData();
    },

    /**
     *  下一页
     */
    handleCurrentChange(val) {
      this.pages.pageNo = val;

      this.queryTableData();
    },
  },
};
</script>